import { IconButton } from 'blaze-ui/IconButton/IconButton'
import Styles from './ChatInput.module.scss'
import { ArrowUp } from 'blaze-ui/icons'
import { useThread } from 'hooks/queries/chat/useThread'
import { ToolsMenu } from './ToolsMenu'
import { RevertMenu } from './RevertMenu'
import { ChatActionsProps } from './Types'

export const ChatActions = ({ onChange, isDisabled, onSubmit, fileId, threadId }: ChatActionsProps) => {
  const { thread } = useThread({ id: threadId }).data || {}
  const { original_design_content, original_caption } = thread || {}
  const hasOriginalContent = original_design_content || original_caption

  return (
    <div className={Styles.actions}>
      <div className={Styles.left}>
        <ToolsMenu onChange={onChange} />
        {hasOriginalContent && fileId && (
          <RevertMenu originalContent={original_design_content} originalCaption={original_caption} fileId={fileId} />
        )}
      </div>
      <IconButton
        aria-label="Ask Blaze"
        icon={ArrowUp}
        className={Styles.submitButton}
        isDisabled={isDisabled}
        onPress={onSubmit}
        size="xs"
        rounded
      />
    </div>
  )
}
